import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'

const dictionary = {
  en: require('../lang/en-IN').default,
  es: require('../lang/es-MX').default
}

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  classNames: 'v-error',
  dictionary
})

// Custom rule globally
Validator.extend('remove_specials', {
  getMessage: (field) => `${field} must not contain special characters.`,
  validate: (value) => {
    return /^[a-zA-Z0-9\s]*$/.test(value)
  }
})
